import { render } from "./Foot.vue?vue&type=template&id=c2308c08&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=c2308c08&scoped=true&lang=less"

import exportComponent from "C:\\Users\\sun\\Desktop\\access_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2308c08"]])

export default __exports__